import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFetchEventSessionAttendees, useUpdateEventSessionAttendeesStatus, isPreflightWarningError, ATTENDEES_PER_PAGE } from 'actions/eventSessions';
import { useAppNameContext } from 'hooks/useAppNameContext';
import useSearchParams from 'hooks/useSearchParams';
import useUniqueId from 'hooks/useUniqueId';
import useBreakpoints from 'hooks/useBreakpoints';
import { getPageFromQuery, getNumberOfPages, locationWithPageNumber } from 'utils/pagination';
import Stack from 'components/Stack';
import Flex, { Box } from 'components/Flex';
import Text from 'components/Text';
import SearchBox from 'components/SearchBox';
import EmptyStateController from 'components/EmptyStateController';
import Landmark from 'components/Landmark';
import TableCard, { Column, InteractiveTableContent } from 'components/TableCard';
import UserTableCell from 'components/UserTableCell';
import { Select, Option } from 'components/Select';
import VisuallyHidden from 'components/VisuallyHidden';
import TitleCard from 'components/TitleCard';
import AddAttendeesMenu from './AddAttendeesMenu';
import ConfirmAttendeeStatusChangeModal from './ConfirmAttendeeStatusChangeModal';
import { sessionQueryParameters } from '../../utils';
import { isAttendeeStatus, renderAttendeeStatusOptions } from './utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function hasNoAttendeeIds(_ref) {
  var _ref$attendeeIds = _ref.attendeeIds,
    attendeeIds = _ref$attendeeIds === void 0 ? [] : _ref$attendeeIds;
  return attendeeIds.length === 0;
}
function SessionAttendeesPage(_ref2) {
  var isNested = _ref2.isNested,
    eventId = _ref2.eventId,
    sessionId = _ref2.sessionId,
    sessionCapacity = _ref2.sessionCapacity,
    sessionAttendeesCount = _ref2.sessionAttendeesCount,
    overallContentAudienceType = _ref2.overallContentAudienceType;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];
  var appNameContext = useAppNameContext();
  var _useBreakpoints = useBreakpoints('xs'),
    isDesktop = _useBreakpoints.xs;
  var attendeeStatusSelectId = useUniqueId('attendee-status-select');
  var mobileAttendeeStatusSelectId = useUniqueId('mobile-attendee-status-select');
  var attendeesStatusFilterLabelId = useUniqueId('attendees-status-filter-label');
  var attendeesPageQueryParameter = sessionQueryParameters.attendeesPage;
  var attendeesSearchQueryParameter = sessionQueryParameters.attendeesSearch;
  var attendeesStatusQueryParameter = sessionQueryParameters.attendeesStatus;
  var currentPage = getPageFromQuery({
    query: searchParams,
    pageQueryParameter: attendeesPageQueryParameter
  });
  var searchValue = searchParams[attendeesSearchQueryParameter];
  var statusValue = isAttendeeStatus(searchParams[attendeesStatusQueryParameter]) ? searchParams[attendeesStatusQueryParameter] : undefined;
  var _useState = useState(searchValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    searchInput = _useState2[0],
    setSearchInput = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAttendeeIds = _useState4[0],
    setSelectedAttendeeIds = _useState4[1];
  var _useState5 = useState(function () {
      return new Set();
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    pendingRowAttendeeIds = _useState6[0],
    setPendingRowAttendeeIds = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    multiSelectStatus = _useState8[0],
    setMultiSelectStatus = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    pendingAttendeeStatusUpdate = _useState0[0],
    setPendingAttendeeStatusUpdate = _useState0[1];
  useEffect(function () {
    setSearchInput(searchValue || '');
  }, [searchValue]);
  useEffect(function () {
    if (!selectedAttendeeIds.length) {
      setMultiSelectStatus('');
    }
  }, [selectedAttendeeIds.length]);
  var _useUpdateEventSessio = useUpdateEventSessionAttendeesStatus({
      eventId: eventId,
      sessionId: sessionId
    }),
    isUpdatingAttendeeStatus = _useUpdateEventSessio.isPending,
    updateEventSessionAttendeesStatus = _useUpdateEventSessio.updateEventSessionAttendeesStatus;
  var _useFetchEventSession = useFetchEventSessionAttendees({
      eventId: eventId,
      sessionId: sessionId,
      page: currentPage,
      limit: ATTENDEES_PER_PAGE,
      search: searchValue,
      status: statusValue
    }),
    attendees = _useFetchEventSession.items,
    total = _useFetchEventSession.total,
    isAttendeesListLoading = _useFetchEventSession.isLoading,
    isAttendeesListError = _useFetchEventSession.isError;
  var pageCount = getNumberOfPages({
    total: total,
    itemsPerPage: ATTENDEES_PER_PAGE
  });
  var attendeesRows = useMemo(function () {
    return attendees.map(function (attendee) {
      return _objectSpread(_objectSpread({}, attendee), {}, {
        resolvedStatus: attendee.status
      });
    });
  }, [attendees]);
  useEffect(function () {
    var visibleAttendeeIds = new Set(attendees.map(function (attendee) {
      return attendee.id;
    }));
    setSelectedAttendeeIds(function (currentSelectedAttendeeIds) {
      var nextSelectedAttendeeIds = currentSelectedAttendeeIds.filter(function (selectedId) {
        return visibleAttendeeIds.has(selectedId);
      });

      // Preserve the same array reference when selection is unchanged to avoid a redundant state update.
      if (nextSelectedAttendeeIds.length === currentSelectedAttendeeIds.length) {
        return currentSelectedAttendeeIds;
      }
      return nextSelectedAttendeeIds;
    });
  }, [attendees]);
  function onSubmitSearch(e) {
    e.preventDefault();
    setSearchParams(_defineProperty(_defineProperty({}, attendeesPageQueryParameter, 1), attendeesSearchQueryParameter, searchInput.trim() || undefined));
  }
  function onClearSearch() {
    setSearchInput('');
    setSearchParams(_defineProperty(_defineProperty({}, attendeesPageQueryParameter, 1), attendeesSearchQueryParameter, undefined));
  }
  function onChangeStatusFilter(value) {
    setSearchParams(_defineProperty(_defineProperty({}, attendeesPageQueryParameter, 1), attendeesStatusQueryParameter, value || undefined));
  }

  // Tracks which individual rows are mid-update so their per-row status
  // select can be disabled while the request is in flight, preventing a
  // second status change being triggered before the first one completes.
  function setRowsWithPendingUpdates(attendeeIds, isPending) {
    setPendingRowAttendeeIds(function (currentPendingRowAttendeeIds) {
      var nextPendingRowAttendeeIds = new Set(currentPendingRowAttendeeIds);
      attendeeIds.forEach(function (attendeeId) {
        if (isPending) {
          nextPendingRowAttendeeIds.add(attendeeId);
          return;
        }
        nextPendingRowAttendeeIds.delete(attendeeId);
      });
      return nextPendingRowAttendeeIds;
    });
  }
  function requestAttendeeStatusUpdate(_x) {
    return _requestAttendeeStatusUpdate.apply(this, arguments);
  }
  function _requestAttendeeStatusUpdate() {
    _requestAttendeeStatusUpdate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var attendeeIds, status, _ref3$isMultiSelect, isMultiSelect, _t;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            attendeeIds = _ref3.attendeeIds, status = _ref3.status, _ref3$isMultiSelect = _ref3.isMultiSelect, isMultiSelect = _ref3$isMultiSelect === void 0 ? false : _ref3$isMultiSelect;
            if (!hasNoAttendeeIds({
              attendeeIds: attendeeIds
            })) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return", {
              isWarned: false
            });
          case 1:
            setRowsWithPendingUpdates(attendeeIds, true);
            _context2.prev = 2;
            _context2.next = 3;
            return updateEventSessionAttendeesStatus({
              attendeeIds: attendeeIds,
              status: status,
              // By default, we initially don't want to proceed with updates that have warnings,
              // as the UI handles this by showing a confirmation modal with the relevant warning information.
              overrideWarnings: false
            });
          case 3:
            _context2.next = 6;
            break;
          case 4:
            _context2.prev = 4;
            _t = _context2["catch"](2);
            if (!isPreflightWarningError(_t)) {
              _context2.next = 5;
              break;
            }
            setPendingAttendeeStatusUpdate({
              attendeeIds: attendeeIds,
              status: status,
              isMultiSelect: isMultiSelect,
              conflictUsers: _t.conflictUsers || [],
              overCapacity: _t.overCapacity
            });
            return _context2.abrupt("return", {
              isWarned: true
            });
          case 5:
            return _context2.abrupt("return", {
              isWarned: false
            });
          case 6:
            _context2.prev = 6;
            setRowsWithPendingUpdates(attendeeIds, false);
            return _context2.finish(6);
          case 7:
            return _context2.abrupt("return", {
              isWarned: false
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 4, 6, 7]]);
    }));
    return _requestAttendeeStatusUpdate.apply(this, arguments);
  }
  function onChangeMultiSelectStatus(_x2) {
    return _onChangeMultiSelectStatus.apply(this, arguments);
  }
  function _onChangeMultiSelectStatus() {
    _onChangeMultiSelectStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value) {
      var _yield$requestAttende, warned;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setMultiSelectStatus(value);
            if (isAttendeeStatus(value)) {
              _context3.next = 1;
              break;
            }
            return _context3.abrupt("return");
          case 1:
            _context3.next = 2;
            return requestAttendeeStatusUpdate({
              attendeeIds: selectedAttendeeIds,
              status: value,
              isMultiSelect: true
            });
          case 2:
            _yield$requestAttende = _context3.sent;
            warned = _yield$requestAttende.isWarned;
            // Keep the selected action value only when showing the preflight warning modal.
            if (!warned) {
              setMultiSelectStatus('');
            }
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _onChangeMultiSelectStatus.apply(this, arguments);
  }
  function onConfirmPendingStatusUpdate() {
    return _onConfirmPendingStatusUpdate.apply(this, arguments);
  }
  function _onConfirmPendingStatusUpdate() {
    _onConfirmPendingStatusUpdate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var attendeeIds, status;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (pendingAttendeeStatusUpdate) {
              _context4.next = 1;
              break;
            }
            return _context4.abrupt("return");
          case 1:
            attendeeIds = pendingAttendeeStatusUpdate.attendeeIds, status = pendingAttendeeStatusUpdate.status;
            if (!hasNoAttendeeIds({
              attendeeIds: attendeeIds
            })) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            setRowsWithPendingUpdates(attendeeIds, true);
            _context4.prev = 3;
            _context4.next = 4;
            return updateEventSessionAttendeesStatus({
              attendeeIds: attendeeIds,
              status: status,
              overrideWarnings: true
            });
          case 4:
            _context4.prev = 4;
            setRowsWithPendingUpdates(attendeeIds, false);
            return _context4.finish(4);
          case 5:
            setPendingAttendeeStatusUpdate(null);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[3,, 4, 5]]);
    }));
    return _onConfirmPendingStatusUpdate.apply(this, arguments);
  }
  function renderMultiStatusSelect(labelId) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(VisuallyHidden, {
        as: "label",
        id: labelId,
        children: t('property_attendance_status')
      }), /*#__PURE__*/_jsxs(Select, {
        size: "small",
        variant: "primary",
        labelledById: labelId,
        menuPlacement: "bottom-start",
        value: multiSelectStatus,
        onChange: onChangeMultiSelectStatus,
        isDisabled: !selectedAttendeeIds.length || isUpdatingAttendeeStatus,
        children: [/*#__PURE__*/_jsx(Option, {
          value: "",
          children: t('actions_update_selection')
        }), renderAttendeeStatusOptions()]
      })]
    });
  }
  function renderStatusFilter(menuPlacement) {
    return /*#__PURE__*/_jsxs(Flex, {
      align: "center",
      gap: "xxs",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "label",
        id: attendeesStatusFilterLabelId,
        mr: "xxs",
        children: t('actions_filter_by_attendance_status_colon')
      }), /*#__PURE__*/_jsxs(Select, {
        size: "medium",
        labelledById: attendeesStatusFilterLabelId,
        menuPlacement: menuPlacement,
        value: statusValue || '',
        onChange: onChangeStatusFilter,
        variant: "transparent",
        children: [/*#__PURE__*/_jsx(Option, {
          value: "",
          children: t('state_any')
        }), renderAttendeeStatusOptions()]
      })]
    });
  }
  function renderSearchForm() {
    return /*#__PURE__*/_jsx("form", {
      onSubmit: onSubmitSearch,
      children: /*#__PURE__*/_jsx(SearchBox, {
        withBorder: true,
        label: t('actions_search_members'),
        placeholder: t('actions_search_members'),
        value: searchInput,
        onChange: function onChange(e) {
          return setSearchInput(e.currentTarget.value);
        },
        onClear: onClearSearch
      })
    });
  }
  function renderStatusHeader(column) {
    if (column.name === 'member') {
      return /*#__PURE__*/_jsxs(Stack, {
        spacing: "xxs",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "span",
          bold: true,
          children: column.title
        }), /*#__PURE__*/_jsx(Text, {
          as: "span",
          children: t('generic_selection_status_short', {
            count: selectedAttendeeIds.length
          })
        })]
      });
    }
    if (column.name !== 'attendanceStatus' || !isDesktop) {
      return /*#__PURE__*/_jsx(Text, {
        bold: true,
        children: column.title
      });
    }
    return /*#__PURE__*/_jsxs(Stack, {
      spacing: "xxs",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        bold: true,
        children: column.title
      }), /*#__PURE__*/_jsx(Box, {
        children: renderMultiStatusSelect(attendeeStatusSelectId)
      })]
    });
  }
  return /*#__PURE__*/_jsx(TitleCard, {
    title: t('actions_manage_attendees'),
    variant: "raised",
    headingLevel: isNested ? 'h3' : 'h2',
    sideContent: /*#__PURE__*/_jsx(AddAttendeesMenu, {
      sessionId: sessionId,
      eventId: eventId,
      sessionCapacity: sessionCapacity,
      sessionAttendeesCount: sessionAttendeesCount,
      overallContentAudienceType: overallContentAudienceType
    }),
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "m",
      children: [isDesktop ? /*#__PURE__*/_jsxs(Flex, {
        align: "center",
        justifyContent: "space-between",
        gap: "s",
        children: [renderSearchForm(), renderStatusFilter('bottom-end')]
      }) : /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [/*#__PURE__*/_jsx(Box, {
          width: "100%",
          children: renderSearchForm()
        }), renderStatusFilter('bottom-start')]
      }), /*#__PURE__*/_jsxs(EmptyStateController, {
        isError: isAttendeesListError,
        height: 250,
        children: [/*#__PURE__*/_jsx(VisuallyHidden, {
          as: "span",
          role: "status",
          "aria-live": "polite",
          "aria-atomic": "true",
          children: t('generic_selection_status_short', {
            count: selectedAttendeeIds.length
          })
        }), /*#__PURE__*/_jsxs(TableCard, {
          isSelectionTable: true,
          isLoading: isAttendeesListLoading,
          mobileSelectionContent: !isDesktop && /*#__PURE__*/_jsx(Flex, {
            gap: "xs",
            children: renderMultiStatusSelect(mobileAttendeeStatusSelectId)
          }),
          emptyContent: /*#__PURE__*/_jsx(Landmark, {
            icon: "user",
            height: 250,
            children: t('empty_no_members')
          }),
          data: attendeesRows,
          itemKey: "id",
          selectedItems: selectedAttendeeIds,
          onChangeSelectedItems: setSelectedAttendeeIds,
          getItemLabel: function getItemLabel(attendee) {
            return attendee.name;
          },
          pageCount: pageCount,
          currentPage: currentPage,
          getPageLink: function getPageLink(pageNumber) {
            return locationWithPageNumber({
              location: location,
              page: pageNumber,
              pageQueryParameter: attendeesPageQueryParameter
            });
          },
          rowHeader: t('property_member'),
          headerRenderer: renderStatusHeader,
          children: [/*#__PURE__*/_jsx(Column, {
            title: t('property_member'),
            name: "member",
            cellRenderer: function cellRenderer(attendee) {
              var isDeleted = attendee.isDeleted;
              var isAdminDashboard = appNameContext === 'admin';
              var attendeeSearch = encodeURIComponent("id:".concat(attendee.userId).concat(isDeleted ? ' is:deleted' : ''));
              var usersPath = isAdminDashboard ? '/users' : '/admin/users';
              var link = "".concat(usersPath, "?search=").concat(attendeeSearch);
              return /*#__PURE__*/_jsx(UserTableCell, {
                target: isAdminDashboard ? '' : '_blank',
                id: attendee.userId,
                link: link,
                email: attendee.email,
                userName: attendee.name,
                avatarUrl: attendee.pictureUrl || undefined,
                isDeleted: isDeleted
              });
            }
          }), /*#__PURE__*/_jsx(Column, {
            title: t('property_attendance_status'),
            name: "attendanceStatus",
            width: "30%",
            cellRenderer: function cellRenderer(attendee) {
              var attendeeId = attendee.id;
              var attendeeIdString = String(attendeeId);
              var selectedStatus = attendee.resolvedStatus;
              var statusLabelId = "attendee-status-".concat(attendeeIdString, "-label");
              return /*#__PURE__*/_jsxs(InteractiveTableContent, {
                children: [/*#__PURE__*/_jsx(VisuallyHidden, {
                  id: statusLabelId,
                  children: t('property_attendance_status')
                }), /*#__PURE__*/_jsx(Select, {
                  size: "small",
                  labelledById: statusLabelId,
                  menuPlacement: "bottom-start",
                  value: selectedStatus,
                  isDisabled: pendingRowAttendeeIds.has(attendee.id),
                  onChange: function onChange(nextStatus) {
                    return requestAttendeeStatusUpdate({
                      attendeeIds: [attendeeId],
                      status: nextStatus
                    });
                  },
                  children: renderAttendeeStatusOptions()
                })]
              });
            }
          })]
        })]
      }), pendingAttendeeStatusUpdate && /*#__PURE__*/_jsx(ConfirmAttendeeStatusChangeModal, {
        isLoading: isUpdatingAttendeeStatus,
        newStatus: pendingAttendeeStatusUpdate.status,
        conflictUsers: pendingAttendeeStatusUpdate.conflictUsers,
        overCapacity: pendingAttendeeStatusUpdate.overCapacity,
        onClose: function onClose() {
          if (pendingAttendeeStatusUpdate.isMultiSelect) {
            setMultiSelectStatus('');
          }
          setPendingAttendeeStatusUpdate(null);
        },
        onConfirm: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return onConfirmPendingStatusUpdate();
              case 1:
                if (pendingAttendeeStatusUpdate.isMultiSelect) {
                  setMultiSelectStatus('');
                }
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))
      })]
    })
  });
}
export default SessionAttendeesPage;